import { AssessmentPage } from "./pages/AssessmentPage";
import type { PluginModule } from "../../plugins/types";

const sidelineAssessmentPlugin: PluginModule = {
  routes: [
    {
      path: "assessment",
      element: <AssessmentPage />,
    },
  ],
  navigation: [
    {
      name: "Assessment",
      route: "/assessment",
      icon: "ShieldAlert",
      order: 2,
    },
  ],
  config: {
    name: "sidelineAssessment",
    version: "1.0.0",
    description: "CRT6-based sideline concussion assessment",
  },
};

export default sidelineAssessmentPlugin;
